// extracted by mini-css-extract-plugin
export var card = "_4b-0";
export var content = "_4b-1";
export var contentLoading = "_4b-2";